import Link from 'next/link'
import { PropsWithChildren, ReactNode, useId } from 'react'

interface HeadingElementProps extends PropsWithChildren {
  className?: string
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

const getLabelFromChildren = (children: ReactNode) => {
  if (Array.isArray(children)) {
    const id = children.at(0).props?.text.replace(/\s+/g, '-').toLowerCase()
    return id
  }
  return undefined
}

const HeadingElement = ({
  className,
  as = 'h1',
  children,
}: HeadingElementProps) => {
  const Component = as
  const uniqueId = useId()
  const id = getLabelFromChildren(children) || uniqueId
  return (
    <Component id={id} className={className}>
      <Link href={`#${id}`} aria-hidden="true" tabIndex={-1}>
        {children}
      </Link>
    </Component>
  )
}

export default HeadingElement
